import { useState } from "react";

const Card = ({ image, imageWhite, title, content, isOpen, onToggle }) => {
  return (
    <article className="card">
      <header onClick={onToggle} className="card-header">
        <div className="line-horizontal"></div>

        <div className="header-text">
          <img
            src={isOpen ? image : imageWhite}
            alt={title}
          />
          <div className="line-vertical"></div>
          <h2>{title}</h2>
        </div>
      </header>

      <div className={`about ${isOpen ? "open" : ""}`}>
        <h3>{content}</h3>
      </div>
    </article>
  );
};

export default Card;
